
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import {
  LowerFooterSectionData,
  LowerFooterSectionMethods,
  LowerFooterSectionComputed,
  LowerFooterSectionProps,
} from './LowerFooter';
import { componentMode } from './Footer.config';
import OwcFooterSocialSection from '@owc-packages/Footer/src/SocialSection.vue';
import OwcFooterLegalSection from '@owc-packages/Footer/src/LegalSection.vue';
/**
 * `Lower Footer` - Lower Footer for OneWeb - Lower Footer contains the social and legal sections of the Footer, this component is able to display via slots the corresponding components.
 */

export default ComponentInitializeDispatcher.extend<
  LowerFooterSectionData,
  LowerFooterSectionMethods,
  LowerFooterSectionComputed,
  LowerFooterSectionProps
>({
  name: 'owc-lower-footer',
  components: {
    OwcFooterSocialSection,
    OwcFooterLegalSection,
    SlotContainer,
  },
  data() {
    return {
      centerElements: false,
    };
  },
  props: {
    socialSection: {
      type: Array,
    },
    legalSection: {
      type: Object,
    },
    socialSectionVisibility: {
      type: Boolean,
    },
  },
  computed: {
    isEdit: function(): boolean {
      return componentMode.isEditMode;
    },
  },
  mounted() {
    this.$el.addEventListener('qrCodeActive', () => this.centerLowerFooterContainer());
  },
  methods: {
    centerLowerFooterContainer: function() {
      this.centerElements = true;
    },
  },
});
